export default __webpack_public_path__ + "static/media/java.532ad27e.png";